module.exports = __webpack_public_path__ + "static/mainlogo-b2acaf25cdd9069611f6831099784bc8.svg";